// extracted by mini-css-extract-plugin
module.exports = {"triangle":"index_triangle_27YiL"};